import { newEvent } from "./new-event";

export const events = {
	title: "Eventos en {{place}}",
	newEvent,
	lastEventMonth: "Último mes de evento",
	eventsNumber: "eventos",
	totalClients: "total de clientes",
	averageTicket: "ticket promedio",
	sales: "ventas",
	receipts: "recibos",
	card: {
		pdv: "PDV's abiertos",
		syncAfterClosed: "Subió después del evento",
		lastSyncAfterClosedAt: "Última sincronización en:",
		averageTicket: "Ticket Promedio",
		income: "Facturación",
		clients: "Clientes",
		status: {
			created: "Cerrado",
			finished: "Finalizado",
			running: "Abierto",
			canceled: "Cancelado",
		},
	},
	timeline: {
		label: "otros eventos futuros, modifique el período para ver más",
	},
	tooltip: {
		calculation: "Memoria de cálculo: Valor total pagado - Descuentos otorgados",
		incomeSummaryCalc: "Valores recibidos en eventos realizados este mes",
		minimumConsumption: "complemento de consumo mínimo",
		productSold: "productos vendidos",
		sales: "Ventas",
		service: "servicio",
		ticket: "entrada",
		manualInvoices: "Notas manuales",
	},
};
